import { render, staticRenderFns } from "./horizontal.vue?vue&type=template&id=b2d1fc20&scoped=true"
import script from "./horizontal.vue?vue&type=script&lang=js"
export * from "./horizontal.vue?vue&type=script&lang=js"
import style0 from "./horizontal.vue?vue&type=style&index=0&id=b2d1fc20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d1fc20",
  null
  
)

export default component.exports